import * as runtypes from 'runtypes';
import * as systemInstitution from 'src/models/systemInstitution';

export const SystemInstitutionRecord = runtypes.Dictionary(systemInstitution.types.SystemInstitution, runtypes.String);

export type SystemInstitutionRecord = runtypes.Static<typeof SystemInstitutionRecord>;
